"use strict";

var uniqueByL = require('./uniqueByL.js');

var identity = require('../Strict/identity.js');

module.exports = uniqueL;

function uniqueL(obj) {
  return uniqueByL(identity, obj);
}

;